import { createStore, compose, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import reducers from "../reducers";
import { LOCAL_STORAGE_STATE_KEY } from "../../config/constants";

const saveToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(LOCAL_STORAGE_STATE_KEY, serializedState);
  } catch (e) {}
};

const loadFromLocalStorage = () => {
  try {
    const state = localStorage.getItem(LOCAL_STORAGE_STATE_KEY);
    return state == null ? undefined : JSON.parse(state);
  } catch (e) {
    return undefined;
  }
};

const presistantState = loadFromLocalStorage();

const store = createStore(
  reducers,
  presistantState,
  compose(
    applyMiddleware(thunkMiddleware)
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

store.subscribe(() => {
  const state = store.getState();
  saveToLocalStorage(state);
});

export default store;
